import { IApplicationState } from '../types/redux';

export const selectDomainLocation = (state: IApplicationState) => state.location;
